module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-client-action-buttons"
  }, [(_vm.item) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])]), _c('li', [(_vm.entity.slot_disabled === 1 && _vm.entity.archived_at === '') ? _c('a', {
    on: {
      "click": _vm.enable
    }
  }, [_vm._v("Enable Vehicle Slot")]) : _vm._e()]), _c('li', [(_vm.entity.slot_disabled === 0) ? _c('VehicleSlotDisableReveal', {
    attrs: {
      "item": _vm.entity
    }
  }, [_vm._v("         li")]) : _vm._e()], 1), _c('li', [(!_vm.entity.archived_at) ? _c('a', {
    on: {
      "click": _vm.archive
    }
  }, [_vm._v("Archive")]) : _vm._e()]), _c('li', [_c('a', {
    on: {
      "click": _vm.requestData
    }
  }, [_vm._v("Request data")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.openDoors
    }
  }, [_vm._v("Open Doors")])]), _c('li', [_c('ActionButton', {
    attrs: {
      "action": _vm.activateImmo,
      "confirm": "confirm"
    }
  }, [_vm._v("Activate Immo")])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.closeDoors
    }
  }, [_vm._v("Close Doors")])])])])]) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [(_vm.entity.slot_disabled === 1) ? _c('a', {
    staticClass: "success-text",
    on: {
      "click": _vm.enable
    }
  }, [_vm._v("Enable")]) : _vm._e(), (_vm.entity.slot_disabled === 0) ? _c('VehicleSlotDisableReveal', {
    attrs: {
      "item": _vm.entity
    }
  }) : _vm._e(), (_vm.entity.slot_id) ? _c('swap-asset', {
    attrs: {
      "item": _vm.vehicleSlot
    },
    on: {
      "processSwap": _vm.processSwap
    }
  }) : _vm._e(), (_vm.entity.slot_id) ? _c('move-asset', {
    attrs: {
      "item": _vm.vehicleSlot
    }
  }) : _vm._e(), _c('ToggleHiddenOnMap', {
    attrs: {
      "vehicle": _vm.entity
    }
  }), (_vm.entity.slot_id) ? _c('a', {
    staticClass: "warning-text",
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v("Dismiss")]) : _vm._e(), (_vm.entity.slot_id) ? _c('router-link', {
    staticClass: "alert-text",
    attrs: {
      "to": {
        name: 'operations',
        params: {
          id: _vm.entity.id
        }
      }
    }
  }, [_vm._v("Drain")]) : _vm._e(), _c('ForceRebook', {
    attrs: {
      "vehicle": _vm.entity
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fea7039a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/VehicleSlotButtons.vue
// module id = 2751
// module chunks = 1